import axios from 'axios';
import { toast } from 'react-toastify';
import { unifiedBaseURL } from './api';


const apiVersion = 'v2';
class PortConfigTemplate {
  baseURL = process.env.REACT_APP_BASE_URL + `/api/v2/portConfig`;
  static headers = {}
  constructor(api) {
    // console.log({ api })
    this.api = api
    this.headers = { Authorization: `Bearer ${api.token}`, };
  }


  async getPortConfigTemplates(dc, portType, ataType) {
    console.log("this.headers", portType)

    const { data } = await axios.get(
      `${unifiedBaseURL(dc)}${apiVersion}/portConfig/getPortConfigTemplate`,
      { headers: this.headers, params: { portType, ataType } },
    );
    return data;
  }

  async getPortConfigTemplateByPortType(dc, portType) {
    console.log("this.headers", portType)

    const { data } = await axios.get(
      `${unifiedBaseURL(dc)}${apiVersion}/portConfig/getPortConfigTemplate/${portType}`,
      { headers: this.headers, },
    );
    return data;
  }
}
export default PortConfigTemplate;
